module.exports = __webpack_public_path__ + "static/media/dressRoom1.f272ea6c.png";